function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 9V3h6L6.884 5.116l3.171 3.172-1.768 1.768-3.171-3.172L3 9zm18 0l-2.116-2.116-3.172 3.171-1.768-1.767 3.172-3.172L15 3h6v6zM6.884 18.884L9 21H3v-6l2.116 2.116 3.172-3.171 1.768 1.768-3.172 3.171zm10.232 0l-3.172-3.172 1.768-1.768 3.172 3.172L21 15v6h-6l2.116-2.116z",
  fill: "currentColor"
});

function SvgFullscreen(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDlWM0g5TDYuODgzNjcgNS4xMTYzM0wxMC4wNTUxIDguMjg3NzRMOC4yODczMiAxMC4wNTU1TDUuMTE1OTEgNi44ODQwOUwzIDlaTTIxIDlMMTguODgzOCA2Ljg4Mzc5TDE1LjcxMjEgMTAuMDU1NUwxMy45NDQ0IDguMjg3NjhMMTcuMTE2IDUuMTE2MDJMMTUgM0gyMVY5Wk02Ljg4Mzk3IDE4Ljg4NEw5IDIxSDNWMTVMNS4xMTYyIDE3LjExNjJMOC4yODc2OCAxMy45NDQ3TDEwLjA1NTUgMTUuNzEyNUw2Ljg4Mzk3IDE4Ljg4NFpNMTcuMTE2IDE4Ljg4NEwxMy45NDQzIDE1LjcxMjJMMTUuNzEyMSAxMy45NDQ1TDE4Ljg4MzggMTcuMTE2MkwyMSAxNVYyMUgxNUwxNy4xMTYgMTguODg0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };